import { Headers, Http } from '@angular/http';

export const URL_API: string = 'https://api.decult.pr7.ufrj.br';

export const HEADERS: Headers = new Headers({'Accept': 'application/json; text/plain, */*', 'Content-Type': 'text/plain; application/json'});
export const VERSAO: string = "2.2.1";

export const DESCRICAO: string = "Sistema de Seleção de Eventos da DECULT/PR-7";

export const MAX_TAM_ARQ: number = 10 * 1024 * 1024;



// WEBPACK FOOTER //
// ./src/app/constante.ts